let errorSent = false;

const sendMessage = (message: Record<string, unknown>): void => {
  if (!window.parent || window.parent === window) {
    if (!errorSent) {
      console.error('No parent window, unable to send message');
      errorSent = true;
    }
    return;
  }
  window.parent.postMessage(message, '*');
};

const sendInitialized = (): void => sendMessage({ type: 'initialized' });
const sendError = (error: string): void => sendMessage({ type: 'error', error });

const sendLoggedOut = (): void => sendMessage({ type: 'loggedOut' });

const sendVerificationFinished = (status: 'SUCCESS' | 'FAILED'): void =>
  sendMessage({ type: 'verificationFinished', status });

const sendInvoiceFinished = (status: 'SUCCESS' | 'FAILED'): void => sendMessage({ type: 'invoiceFinished', status });

const sendWithdrawalFinished = (status: 'SUCCESS' | string): void =>
  sendMessage({ type: 'withdrawalFinished', status });

export default {
  sendInitialized,
  sendError,
  sendLoggedOut,
  sendVerificationFinished,
  sendInvoiceFinished,
  sendWithdrawalFinished,
};
